export const socialLink = {
  facebook: 'https://www.facebook.com/redbini/',
  twitter: 'https://twitter.com/redbini_com',
  instagram: 'https://www.instagram.com/redbini_com/',
  youtube: 'https://www.youtube.com/channel/UCohNSyNA5iHBxeVDTJFpoaw',
  pinterest: 'https://www.pinterest.co.uk/redbini_com',
}
export default {
  baseURL: 'https://redbini.com', //https://redbini.fun  http://localhost:8080
  production: true,
  chatURL: 'https://chat.redbini.com', // chat vue url
  apiURL: 'https://api.redbini.com', // https://api.redbini.fun http://192.168.0.120:8090
  chatSocketURL: 'https://chatsocket.redbini.com',
  gtagId: 'GTM-57MVNSQ',
  watermarkLarge: '/static/images/wm_large.png',
  watermarkSmall: '/static/images/wm_small.png',
  watermarkAlpha: 1,
  sounds: {
    chatInvite: '/static/sounds/invite.mp3',
    toast: '/static/sounds/toast.mp3',
    sys_notification: '/static/sounds/sys_notification.mp3',
  },
  lifeTimes: {
    alert: 5000, // ms
    notification: 8000, // ms
    invite: 60000, // ms
  },
  registration: {
    captchaInterval: 30, // minutes
    triesCount: 3,
  },
  wmnAgreementModal: {
    launchInterval: 30, // days
  },
}
